import { useMatch } from 'react-router-dom'
import { navLinks, siteConfig } from '@/lib/site'
import { cn } from '@/lib/utils'
import { useSiteFootnoteContent } from '@shared/SiteFootnote'
import { Wordmark } from '@shared/Wordmark'

export function SiteFooter() {
  // Landing anchors do not exist on prospect pages.
  const isProspectPage = useMatch('/for/:slug') !== null
  const links = isProspectPage ? [] : navLinks
  const footnote = useSiteFootnoteContent()

  return (
    <footer
      className={cn(
        'mt-24 border-t border-black/10 py-10 dark:border-white/[0.08]',
        // Clear the mobile sticky demo bar.
        isProspectPage && 'pb-28 sm:pb-10'
      )}
    >
      <div className="mx-auto flex max-w-6xl flex-col gap-6 px-4 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex flex-col gap-2">
          <Wordmark size="sm" />
          <p className="text-sm text-muted-foreground">{siteConfig.tagline}</p>
        </div>

        <nav className="flex flex-wrap gap-x-5 gap-y-2" aria-label="Footer">
          {links.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="text-sm text-muted-foreground transition-colors hover:text-foreground"
            >
              {link.label}
            </a>
          ))}
          <a
            href={`mailto:${siteConfig.contactEmail}`}
            className="text-sm text-muted-foreground transition-colors hover:text-foreground"
          >
            Contact
          </a>
        </nav>
      </div>

      {footnote && <div className="mx-auto mt-8 max-w-6xl px-4">{footnote}</div>}

      <p className="mx-auto mt-8 max-w-6xl px-4 text-xs text-muted-foreground">
        &copy; {new Date().getFullYear()} {siteConfig.name}. All rights reserved.
      </p>
    </footer>
  )
}
